import React from 'react'
import { Box } from "@mui/material"
import { LoadingIconSeeker } from "@ui-seeker/core"
import { AppButtonIcon } from "@components"

import { loadingEditRowId, loadingRowId } from "Pages/ReportsAlerts/Alerts/Conditions/@signals"


export default function actionsColumn(onDeleteAlert, onEditAlert) {
	return {
		label: 'Actions', name: "actions", options: {
			filter: false, customBodyRowRenderLite: (value, row) => <Box
				sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
				{loadingEditRowId.value === row.idAlert && <LoadingIconSeeker
					fontSize={16}
				/>}
				{loadingEditRowId.value !== row.idAlert && <AppButtonIcon
					icon="pen"
					tooltip="Edit the alert"
					onClick={() => {
						onEditAlert(row.idAlert)
					}}
				/>}
				{loadingRowId.value !== row.idAlert && <AppButtonIcon
					icon="trash-can"
					tooltip="Delete the alert"
					onClick={() => onDeleteAlert(row.idAlert)}
				/>}
				{loadingRowId.value === row.idAlert && <LoadingIconSeeker
					fontSize={16}
				/>}
			</Box>
		}
	}
}